import React from "react";
import { Navigate, useParams } from "react-router-dom";

// /surveys/:surveyId/converse/:insightId/:token — an old AI interviewer link.
//
// The interviewer is retired: every interviewer became an ordinary voice survey
// (Survey.respond_mode "voice") with the same survey id and token, answered on
// /respond/. Links already sent out still say /converse/, so send them there.
export default function ConverseLinkPage() {
    const { surveyId, token } = useParams();
    return <Navigate to={`/surveys/${surveyId}/respond/${token}/${window.location.search || ""}`} replace />;
}
